
<template>
  <div>
    <component :is="componentType"></component>
  </div>
</template>

<script>
export default {
  name: "Home",

  components: {
    PcListTeach: () => import("./ListTeachPc.vue"), // PC端组件
    MobileListTeach: () => import("./Mobile/ListTeachMobile.vue"), // 移动端组件
  },

  computed: {
    componentType() {
      return this.$store.state.isMobile ? "MobileListTeach" : "PcListTeach";
    },
  },
};
</script>

<style scoped></style>
